import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { useTranslation } from 'hooks/useTranslation';
import styles from './PostItem.module.scss';

type Props = {
  createdAt: string;
  className?: string;
};

const BlogDate = ({
  createdAt,
  className = styles.date,
}: Props): JSX.Element => {
  const { t, locale } = useTranslation();
  const locales: Record<string, Locale> = { de, enUS };
  const [date, setDate] = useState('');

  useEffect(() => {
    if (createdAt) {
      setDate(
        format(new Date(createdAt), 'PP', {
          locale: locales[locale] ? locales[locale] : enUS,
        }),
      );
    }
  }, [createdAt]);

  return (
    <time dateTime={createdAt} className={className}>
      {t('blog.posted')} {date}
    </time>
  );
};

export default BlogDate;
